"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.TextBoxWithImage = void 0;
var _textBoxWithImage = _interopRequireDefault(require("./components/text-box-with-image"));
exports.TextBoxWithImage = _textBoxWithImage["default"];